import { GraphQLClient } from 'graphql-request';
import { RequestInit } from 'graphql-request/dist/types.dom';
import { useMutation, useQuery, useInfiniteQuery, UseMutationOptions, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };

function fetcher<TData, TVariables extends { [key: string]: any }>(client: GraphQLClient, query: string, variables?: TVariables, requestHeaders?: RequestInit['headers']) {
  return async (): Promise<TData> => client.request({
    document: query,
    variables,
    requestHeaders
  });
}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: string; output: string; }
  Long: { input: number; output: number; }
};

export type BatchFollowResult = {
  __typename?: 'BatchFollowResult';
  failed: Array<FollowError>;
  successCount: Scalars['Int']['output'];
  successful: Array<User>;
  totalCount: Scalars['Int']['output'];
};

export type BatchUnfollowResult = {
  __typename?: 'BatchUnfollowResult';
  failed: Array<UnfollowError>;
  successCount: Scalars['Int']['output'];
  successful: Array<User>;
  totalCount: Scalars['Int']['output'];
};

export type FollowError = {
  __typename?: 'FollowError';
  reason: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};

/** 팔로우 이벤트 (실시간) */
export type FollowEvent = {
  __typename?: 'FollowEvent';
  /** 대상 사용자 */
  targetUser: User;
  /** 이벤트 발생 시간 */
  timestamp: Scalars['DateTime']['output'];
  /** 이벤트 타입 */
  type: FollowEventType;
  /** 이벤트 발생 사용자 */
  user: User;
};

export enum FollowEventType {
  Followed = 'FOLLOWED',
  Unfollowed = 'UNFOLLOWED'
}

/** 팔로우 관계 */
export type FollowRelationship = {
  __typename?: 'FollowRelationship';
  /** 팔로우 시작 시간 */
  followedAt: Scalars['DateTime']['output'];
  /** 관계 ID */
  id: Scalars['ID']['output'];
  /** 상호 팔로우 여부 */
  isMutual: Scalars['Boolean']['output'];
  /** 알림 활성화 여부 */
  notificationsEnabled: Scalars['Boolean']['output'];
  /** 팔로우한 사용자 */
  user: User;
};

export type FollowResult = {
  __typename?: 'FollowResult';
  message?: Maybe<Scalars['String']['output']>;
  relationship?: Maybe<FollowRelationship>;
  success: Scalars['Boolean']['output'];
  user?: Maybe<User>;
};

/** 팔로우 추천 */
export type FollowSuggestion = {
  __typename?: 'FollowSuggestion';
  /** 상호 팔로워 목록 (최대 3명) */
  mutualFollowers: Array<User>;
  /** 상호 팔로워 수 */
  mutualFollowersCount: Scalars['Int']['output'];
  /** 추천 이유 */
  reason: Scalars['String']['output'];
  /** 추천 점수 */
  score: Scalars['Float']['output'];
  /** 추천 사용자 */
  user: User;
};

export type FollowerConnection = {
  __typename?: 'FollowerConnection';
  edges: Array<FollowerEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Long']['output'];
};

export type FollowerEdge = {
  __typename?: 'FollowerEdge';
  cursor: Scalars['String']['output'];
  followedAt: Scalars['DateTime']['output'];
  isMutual: Scalars['Boolean']['output'];
  node: User;
};

export type FollowingConnection = {
  __typename?: 'FollowingConnection';
  edges: Array<FollowingEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Long']['output'];
};

export type FollowingEdge = {
  __typename?: 'FollowingEdge';
  cursor: Scalars['String']['output'];
  followedAt: Scalars['DateTime']['output'];
  isMutual: Scalars['Boolean']['output'];
  node: User;
  notificationsEnabled: Scalars['Boolean']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** 사용자 팔로우 */
  followUser: FollowResult;
  /** 여러 사용자 팔로우 */
  followUsers: BatchFollowResult;
  /** 사용자 언팔로우 */
  unfollowUser: UnfollowResult;
  /** 여러 사용자 언팔로우 */
  unfollowUsers: BatchUnfollowResult;
  /** 팔로우 알림 설정 */
  updateFollowNotifications: FollowRelationship;
};


export type MutationFollowUserArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationFollowUsersArgs = {
  userIds: Array<Scalars['ID']['input']>;
};


export type MutationUnfollowUserArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationUnfollowUsersArgs = {
  userIds: Array<Scalars['ID']['input']>;
};


export type MutationUpdateFollowNotificationsArgs = {
  enabled: Scalars['Boolean']['input'];
  userId: Scalars['ID']['input'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  /** 관계 확인 */
  checkRelationship: RelationshipStatus;
  /** 팔로우 추천 */
  followSuggestions: Array<FollowSuggestion>;
  /** 현재 사용자 정보 */
  me?: Maybe<User>;
  /** 상호 팔로워 조회 */
  mutualFollowers: Array<User>;
  /** 사용자 검색 */
  searchUsers: Array<User>;
  /** 사용자 조회 */
  user?: Maybe<User>;
  /** 사용자명으로 조회 */
  userByUsername?: Maybe<User>;
};


export type QueryCheckRelationshipArgs = {
  targetUserId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type QueryFollowSuggestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMutualFollowersArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  targetUserId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type QuerySearchUsersArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
};


export type QueryUserArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryUserByUsernameArgs = {
  username: Scalars['String']['input'];
};

/** 관계 상태 */
export type RelationshipStatus = {
  __typename?: 'RelationshipStatus';
  /** 팔로우 시작 시간 */
  followedAt?: Maybe<Scalars['DateTime']['output']>;
  /** 맞팔로우 시작 시간 */
  followedBackAt?: Maybe<Scalars['DateTime']['output']>;
  /** 상대방이 현재 사용자를 팔로우 중 */
  isFollowedBy: Scalars['Boolean']['output'];
  /** 현재 사용자가 팔로우 중 */
  isFollowing: Scalars['Boolean']['output'];
  /** 상호 팔로우 */
  isMutual: Scalars['Boolean']['output'];
};

/** 소셜 통계 */
export type SocialStats = {
  __typename?: 'SocialStats';
  /** 팔로워 수 */
  followersCount: Scalars['Long']['output'];
  /** 팔로잉 수 */
  followingCount: Scalars['Long']['output'];
  /** 상호 팔로워 수 */
  mutualFollowersCount: Scalars['Long']['output'];
  /** 게시물 수 */
  postsCount: Scalars['Long']['output'];
};

export type Subscription = {
  __typename?: 'Subscription';
  /** 실시간 팔로우 이벤트 구독 */
  followEvents: FollowEvent;
  /** 특정 사용자의 팔로워 변경 구독 */
  followerUpdates: FollowEvent;
  /** 특정 사용자의 팔로잉 변경 구독 */
  followingUpdates: FollowEvent;
};


export type SubscriptionFollowEventsArgs = {
  userId: Scalars['ID']['input'];
};


export type SubscriptionFollowerUpdatesArgs = {
  userId: Scalars['ID']['input'];
};


export type SubscriptionFollowingUpdatesArgs = {
  userId: Scalars['ID']['input'];
};

export type UnfollowError = {
  __typename?: 'UnfollowError';
  reason: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};

export type UnfollowResult = {
  __typename?: 'UnfollowResult';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  user?: Maybe<User>;
};

/** 사용자 노드 (Neo4j User Node) */
export type User = {
  __typename?: 'User';
  /** 자기소개 */
  bio?: Maybe<Scalars['String']['output']>;
  /** 계정 생성일 */
  createdAt: Scalars['DateTime']['output'];
  /** 표시 이름 */
  displayName?: Maybe<Scalars['String']['output']>;
  /** 팔로워 목록 */
  followers: FollowerConnection;
  /** 팔로잉 목록 */
  following: FollowingConnection;
  /** 활성 상태 */
  isActive: Scalars['Boolean']['output'];
  /** 상호 팔로워 */
  mutualFollowers: Array<User>;
  /** 프로필 이미지 URL */
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  /** 현재 사용자와의 관계 */
  relationshipWithCurrentUser?: Maybe<RelationshipStatus>;
  /** 소셜 통계 */
  stats: SocialStats;
  /** 사용자 고유 ID */
  userId: Scalars['ID']['output'];
  /** 사용자명 (unique) */
  username: Scalars['String']['output'];
};


/** 사용자 노드 (Neo4j User Node) */
export type UserFollowersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/** 사용자 노드 (Neo4j User Node) */
export type UserFollowingArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/** 사용자 노드 (Neo4j User Node) */
export type UserMutualFollowersArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type FollowUserMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type FollowUserMutation = { __typename?: 'Mutation', followUser: { __typename?: 'FollowResult', success: boolean, message?: string | null, user?: { __typename?: 'User', userId: string, username: string, displayName?: string | null, profileImageUrl?: string | null, stats: { __typename?: 'SocialStats', followersCount: number, followingCount: number }, relationshipWithCurrentUser?: { __typename?: 'RelationshipStatus', isFollowing: boolean, isFollowedBy: boolean } | null } | null } };

export type UnfollowUserMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type UnfollowUserMutation = { __typename?: 'Mutation', unfollowUser: { __typename?: 'UnfollowResult', success: boolean, message?: string | null, user?: { __typename?: 'User', userId: string, username: string, displayName?: string | null, profileImageUrl?: string | null, stats: { __typename?: 'SocialStats', followersCount: number, followingCount: number }, relationshipWithCurrentUser?: { __typename?: 'RelationshipStatus', isFollowing: boolean, isFollowedBy: boolean } | null } | null } };

export type FollowUsersMutationVariables = Exact<{
  userIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type FollowUsersMutation = { __typename?: 'Mutation', followUsers: { __typename?: 'BatchFollowResult', totalCount: number, successCount: number, successful: Array<{ __typename?: 'User', userId: string, username: string }>, failed: Array<{ __typename?: 'FollowError', userId: string, reason: string }> } };

export type UnfollowUsersMutationVariables = Exact<{
  userIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type UnfollowUsersMutation = { __typename?: 'Mutation', unfollowUsers: { __typename?: 'BatchUnfollowResult', totalCount: number, successCount: number, successful: Array<{ __typename?: 'User', userId: string, username: string }>, failed: Array<{ __typename?: 'UnfollowError', userId: string, reason: string }> } };

export type GetFollowersDetailedQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetFollowersDetailedQuery = { __typename?: 'Query', user?: { __typename?: 'User', userId: string, followers: { __typename?: 'FollowerConnection', totalCount: number, edges: Array<{ __typename?: 'FollowerEdge', cursor: string, followedAt: string, isMutual: boolean, node: { __typename?: 'User', userId: string, username: string, displayName?: string | null, profileImageUrl?: string | null, bio?: string | null, relationshipWithCurrentUser?: { __typename?: 'RelationshipStatus', isFollowing: boolean, isFollowedBy: boolean, isMutual: boolean } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null, startCursor?: string | null } } } | null };

export type GetFollowingDetailedQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetFollowingDetailedQuery = { __typename?: 'Query', user?: { __typename?: 'User', userId: string, following: { __typename?: 'FollowingConnection', totalCount: number, edges: Array<{ __typename?: 'FollowingEdge', cursor: string, followedAt: string, isMutual: boolean, notificationsEnabled: boolean, node: { __typename?: 'User', userId: string, username: string, displayName?: string | null, profileImageUrl?: string | null, bio?: string | null, relationshipWithCurrentUser?: { __typename?: 'RelationshipStatus', isFollowing: boolean, isFollowedBy: boolean, isMutual: boolean } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null, startCursor?: string | null } } } | null };

export type GetRelationshipStatusQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  targetUserId: Scalars['ID']['input'];
}>;


export type GetRelationshipStatusQuery = { __typename?: 'Query', checkRelationship: { __typename?: 'RelationshipStatus', isFollowing: boolean, isFollowedBy: boolean, isMutual: boolean, followedAt?: string | null, followedBackAt?: string | null } };

export type GetMutualFollowersQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  targetUserId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetMutualFollowersQuery = { __typename?: 'Query', mutualFollowers: Array<{ __typename?: 'User', userId: string, username: string, displayName?: string | null, profileImageUrl?: string | null, bio?: string | null, stats: { __typename?: 'SocialStats', followersCount: number } }> };

export type GetUserQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type GetUserQuery = { __typename?: 'Query', user?: { __typename?: 'User', userId: string, username: string, displayName?: string | null, profileImageUrl?: string | null, bio?: string | null, stats: { __typename?: 'SocialStats', followersCount: number, followingCount: number, postsCount: number }, relationshipWithCurrentUser?: { __typename?: 'RelationshipStatus', isFollowing: boolean, isFollowedBy: boolean, isMutual: boolean } | null } | null };

export type GetUserByUsernameQueryVariables = Exact<{
  username: Scalars['String']['input'];
}>;


export type GetUserByUsernameQuery = { __typename?: 'Query', userByUsername?: { __typename?: 'User', userId: string, username: string, displayName?: string | null, profileImageUrl?: string | null, bio?: string | null, stats: { __typename?: 'SocialStats', followersCount: number, followingCount: number, postsCount: number }, relationshipWithCurrentUser?: { __typename?: 'RelationshipStatus', isFollowing: boolean, isFollowedBy: boolean, isMutual: boolean } | null } | null };

export type GetMeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMeQuery = { __typename?: 'Query', me?: { __typename?: 'User', userId: string, username: string, displayName?: string | null, profileImageUrl?: string | null, bio?: string | null, stats: { __typename?: 'SocialStats', followersCount: number, followingCount: number, postsCount: number } } | null };

export type SearchUsersQueryVariables = Exact<{
  query: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchUsersQuery = { __typename?: 'Query', searchUsers: Array<{ __typename?: 'User', userId: string, username: string, displayName?: string | null, profileImageUrl?: string | null, bio?: string | null, stats: { __typename?: 'SocialStats', followersCount: number }, relationshipWithCurrentUser?: { __typename?: 'RelationshipStatus', isFollowing: boolean } | null }> };

export type GetFollowersQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetFollowersQuery = { __typename?: 'Query', user?: { __typename?: 'User', followers: { __typename?: 'FollowerConnection', totalCount: number, edges: Array<{ __typename?: 'FollowerEdge', cursor: string, node: { __typename?: 'User', userId: string, username: string, displayName?: string | null, profileImageUrl?: string | null, stats: { __typename?: 'SocialStats', followersCount: number }, relationshipWithCurrentUser?: { __typename?: 'RelationshipStatus', isFollowing: boolean } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } } | null };

export type GetFollowingQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetFollowingQuery = { __typename?: 'Query', user?: { __typename?: 'User', following: { __typename?: 'FollowingConnection', totalCount: number, edges: Array<{ __typename?: 'FollowingEdge', cursor: string, node: { __typename?: 'User', userId: string, username: string, displayName?: string | null, profileImageUrl?: string | null, stats: { __typename?: 'SocialStats', followersCount: number }, relationshipWithCurrentUser?: { __typename?: 'RelationshipStatus', isFollowing: boolean } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } } | null };

export type GetFollowersByUsernameQueryVariables = Exact<{
  username: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetFollowersByUsernameQuery = { __typename?: 'Query', userByUsername?: { __typename?: 'User', userId: string, username: string, displayName?: string | null, profileImageUrl?: string | null, bio?: string | null, stats: { __typename?: 'SocialStats', followersCount: number, followingCount: number, postsCount: number }, relationshipWithCurrentUser?: { __typename?: 'RelationshipStatus', isFollowing: boolean, isFollowedBy: boolean, isMutual: boolean } | null, followers: { __typename?: 'FollowerConnection', totalCount: number, edges: Array<{ __typename?: 'FollowerEdge', cursor: string, followedAt: string, isMutual: boolean, node: { __typename?: 'User', userId: string, username: string, displayName?: string | null, profileImageUrl?: string | null, bio?: string | null, stats: { __typename?: 'SocialStats', followersCount: number }, relationshipWithCurrentUser?: { __typename?: 'RelationshipStatus', isFollowing: boolean } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } } | null };

export type GetFollowingByUsernameQueryVariables = Exact<{
  username: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetFollowingByUsernameQuery = { __typename?: 'Query', userByUsername?: { __typename?: 'User', userId: string, username: string, displayName?: string | null, profileImageUrl?: string | null, bio?: string | null, stats: { __typename?: 'SocialStats', followersCount: number, followingCount: number, postsCount: number }, relationshipWithCurrentUser?: { __typename?: 'RelationshipStatus', isFollowing: boolean, isFollowedBy: boolean, isMutual: boolean } | null, following: { __typename?: 'FollowingConnection', totalCount: number, edges: Array<{ __typename?: 'FollowingEdge', cursor: string, followedAt: string, isMutual: boolean, node: { __typename?: 'User', userId: string, username: string, displayName?: string | null, profileImageUrl?: string | null, bio?: string | null, stats: { __typename?: 'SocialStats', followersCount: number }, relationshipWithCurrentUser?: { __typename?: 'RelationshipStatus', isFollowing: boolean } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } } | null };

export type CheckRelationshipQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  targetUserId: Scalars['ID']['input'];
}>;


export type CheckRelationshipQuery = { __typename?: 'Query', checkRelationship: { __typename?: 'RelationshipStatus', isFollowing: boolean, isFollowedBy: boolean, isMutual: boolean, followedAt?: string | null, followedBackAt?: string | null } };

export type GetFollowSuggestionsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetFollowSuggestionsQuery = { __typename?: 'Query', followSuggestions: Array<{ __typename?: 'FollowSuggestion', reason: string, mutualFollowersCount: number, score: number, user: { __typename?: 'User', userId: string, username: string, displayName?: string | null, profileImageUrl?: string | null, bio?: string | null, stats: { __typename?: 'SocialStats', followersCount: number } }, mutualFollowers: Array<{ __typename?: 'User', userId: string, username: string, displayName?: string | null, profileImageUrl?: string | null }> }> };



export const FollowUserDocument = /*#__PURE__*/ `
    mutation FollowUser($userId: ID!) {
  followUser(userId: $userId) {
    success
    message
    user {
      userId
      username
      displayName
      profileImageUrl
      stats {
        followersCount
        followingCount
      }
      relationshipWithCurrentUser {
        isFollowing
        isFollowedBy
      }
    }
  }
}
    `;

export const useFollowUserMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<FollowUserMutation, TError, FollowUserMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<FollowUserMutation, TError, FollowUserMutationVariables, TContext>(
      {
    mutationKey: ['FollowUser'],
    mutationFn: (variables?: FollowUserMutationVariables) => fetcher<FollowUserMutation, FollowUserMutationVariables>(client, FollowUserDocument, variables, headers)(),
    ...options
  }
    )};

useFollowUserMutation.getKey = () => ['FollowUser'];


useFollowUserMutation.fetcher = (client: GraphQLClient, variables: FollowUserMutationVariables, headers?: RequestInit['headers']) => fetcher<FollowUserMutation, FollowUserMutationVariables>(client, FollowUserDocument, variables, headers);

export const UnfollowUserDocument = /*#__PURE__*/ `
    mutation UnfollowUser($userId: ID!) {
  unfollowUser(userId: $userId) {
    success
    message
    user {
      userId
      username
      displayName
      profileImageUrl
      stats {
        followersCount
        followingCount
      }
      relationshipWithCurrentUser {
        isFollowing
        isFollowedBy
      }
    }
  }
}
    `;

export const useUnfollowUserMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UnfollowUserMutation, TError, UnfollowUserMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UnfollowUserMutation, TError, UnfollowUserMutationVariables, TContext>(
      {
    mutationKey: ['UnfollowUser'],
    mutationFn: (variables?: UnfollowUserMutationVariables) => fetcher<UnfollowUserMutation, UnfollowUserMutationVariables>(client, UnfollowUserDocument, variables, headers)(),
    ...options
  }
    )};

useUnfollowUserMutation.getKey = () => ['UnfollowUser'];


useUnfollowUserMutation.fetcher = (client: GraphQLClient, variables: UnfollowUserMutationVariables, headers?: RequestInit['headers']) => fetcher<UnfollowUserMutation, UnfollowUserMutationVariables>(client, UnfollowUserDocument, variables, headers);

export const FollowUsersDocument = /*#__PURE__*/ `
    mutation FollowUsers($userIds: [ID!]!) {
  followUsers(userIds: $userIds) {
    successful {
      userId
      username
    }
    failed {
      userId
      reason
    }
    totalCount
    successCount
  }
}
    `;

export const useFollowUsersMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<FollowUsersMutation, TError, FollowUsersMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<FollowUsersMutation, TError, FollowUsersMutationVariables, TContext>(
      {
    mutationKey: ['FollowUsers'],
    mutationFn: (variables?: FollowUsersMutationVariables) => fetcher<FollowUsersMutation, FollowUsersMutationVariables>(client, FollowUsersDocument, variables, headers)(),
    ...options
  }
    )};

useFollowUsersMutation.getKey = () => ['FollowUsers'];


useFollowUsersMutation.fetcher = (client: GraphQLClient, variables: FollowUsersMutationVariables, headers?: RequestInit['headers']) => fetcher<FollowUsersMutation, FollowUsersMutationVariables>(client, FollowUsersDocument, variables, headers);

export const UnfollowUsersDocument = /*#__PURE__*/ `
    mutation UnfollowUsers($userIds: [ID!]!) {
  unfollowUsers(userIds: $userIds) {
    successful {
      userId
      username
    }
    failed {
      userId
      reason
    }
    totalCount
    successCount
  }
}
    `;

export const useUnfollowUsersMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UnfollowUsersMutation, TError, UnfollowUsersMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UnfollowUsersMutation, TError, UnfollowUsersMutationVariables, TContext>(
      {
    mutationKey: ['UnfollowUsers'],
    mutationFn: (variables?: UnfollowUsersMutationVariables) => fetcher<UnfollowUsersMutation, UnfollowUsersMutationVariables>(client, UnfollowUsersDocument, variables, headers)(),
    ...options
  }
    )};

useUnfollowUsersMutation.getKey = () => ['UnfollowUsers'];


useUnfollowUsersMutation.fetcher = (client: GraphQLClient, variables: UnfollowUsersMutationVariables, headers?: RequestInit['headers']) => fetcher<UnfollowUsersMutation, UnfollowUsersMutationVariables>(client, UnfollowUsersDocument, variables, headers);

export const GetFollowersDetailedDocument = /*#__PURE__*/ `
    query GetFollowersDetailed($userId: ID!, $first: Int, $after: String) {
  user(userId: $userId) {
    userId
    followers(first: $first, after: $after) {
      edges {
        node {
          userId
          username
          displayName
          profileImageUrl
          bio
          relationshipWithCurrentUser {
            isFollowing
            isFollowedBy
            isMutual
          }
        }
        cursor
        followedAt
        isMutual
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
        startCursor
      }
      totalCount
    }
  }
}
    `;

export const useGetFollowersDetailedQuery = <
      TData = GetFollowersDetailedQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetFollowersDetailedQueryVariables,
      options?: Omit<UseQueryOptions<GetFollowersDetailedQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetFollowersDetailedQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetFollowersDetailedQuery, TError, TData>(
      {
    queryKey: ['GetFollowersDetailed', variables],
    queryFn: fetcher<GetFollowersDetailedQuery, GetFollowersDetailedQueryVariables>(client, GetFollowersDetailedDocument, variables, headers),
    ...options
  }
    )};

useGetFollowersDetailedQuery.getKey = (variables: GetFollowersDetailedQueryVariables) => ['GetFollowersDetailed', variables];

export const useInfiniteGetFollowersDetailedQuery = <
      TData = InfiniteData<GetFollowersDetailedQuery>,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetFollowersDetailedQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetFollowersDetailedQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetFollowersDetailedQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useInfiniteQuery<GetFollowersDetailedQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetFollowersDetailed.infinite', variables],
      queryFn: (metaData) => fetcher<GetFollowersDetailedQuery, GetFollowersDetailedQueryVariables>(client, GetFollowersDetailedDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetFollowersDetailedQuery.getKey = (variables: GetFollowersDetailedQueryVariables) => ['GetFollowersDetailed.infinite', variables];


useGetFollowersDetailedQuery.fetcher = (client: GraphQLClient, variables: GetFollowersDetailedQueryVariables, headers?: RequestInit['headers']) => fetcher<GetFollowersDetailedQuery, GetFollowersDetailedQueryVariables>(client, GetFollowersDetailedDocument, variables, headers);

export const GetFollowingDetailedDocument = /*#__PURE__*/ `
    query GetFollowingDetailed($userId: ID!, $first: Int, $after: String) {
  user(userId: $userId) {
    userId
    following(first: $first, after: $after) {
      edges {
        node {
          userId
          username
          displayName
          profileImageUrl
          bio
          relationshipWithCurrentUser {
            isFollowing
            isFollowedBy
            isMutual
          }
        }
        cursor
        followedAt
        isMutual
        notificationsEnabled
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
        startCursor
      }
      totalCount
    }
  }
}
    `;

export const useGetFollowingDetailedQuery = <
      TData = GetFollowingDetailedQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetFollowingDetailedQueryVariables,
      options?: Omit<UseQueryOptions<GetFollowingDetailedQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetFollowingDetailedQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetFollowingDetailedQuery, TError, TData>(
      {
    queryKey: ['GetFollowingDetailed', variables],
    queryFn: fetcher<GetFollowingDetailedQuery, GetFollowingDetailedQueryVariables>(client, GetFollowingDetailedDocument, variables, headers),
    ...options
  }
    )};

useGetFollowingDetailedQuery.getKey = (variables: GetFollowingDetailedQueryVariables) => ['GetFollowingDetailed', variables];

export const useInfiniteGetFollowingDetailedQuery = <
      TData = InfiniteData<GetFollowingDetailedQuery>,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetFollowingDetailedQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetFollowingDetailedQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetFollowingDetailedQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useInfiniteQuery<GetFollowingDetailedQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetFollowingDetailed.infinite', variables],
      queryFn: (metaData) => fetcher<GetFollowingDetailedQuery, GetFollowingDetailedQueryVariables>(client, GetFollowingDetailedDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetFollowingDetailedQuery.getKey = (variables: GetFollowingDetailedQueryVariables) => ['GetFollowingDetailed.infinite', variables];


useGetFollowingDetailedQuery.fetcher = (client: GraphQLClient, variables: GetFollowingDetailedQueryVariables, headers?: RequestInit['headers']) => fetcher<GetFollowingDetailedQuery, GetFollowingDetailedQueryVariables>(client, GetFollowingDetailedDocument, variables, headers);

export const GetRelationshipStatusDocument = /*#__PURE__*/ `
    query GetRelationshipStatus($userId: ID!, $targetUserId: ID!) {
  checkRelationship(userId: $userId, targetUserId: $targetUserId) {
    isFollowing
    isFollowedBy
    isMutual
    followedAt
    followedBackAt
  }
}
    `;

export const useGetRelationshipStatusQuery = <
      TData = GetRelationshipStatusQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetRelationshipStatusQueryVariables,
      options?: Omit<UseQueryOptions<GetRelationshipStatusQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetRelationshipStatusQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetRelationshipStatusQuery, TError, TData>(
      {
    queryKey: ['GetRelationshipStatus', variables],
    queryFn: fetcher<GetRelationshipStatusQuery, GetRelationshipStatusQueryVariables>(client, GetRelationshipStatusDocument, variables, headers),
    ...options
  }
    )};

useGetRelationshipStatusQuery.getKey = (variables: GetRelationshipStatusQueryVariables) => ['GetRelationshipStatus', variables];

export const useInfiniteGetRelationshipStatusQuery = <
      TData = InfiniteData<GetRelationshipStatusQuery>,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetRelationshipStatusQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetRelationshipStatusQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetRelationshipStatusQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useInfiniteQuery<GetRelationshipStatusQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetRelationshipStatus.infinite', variables],
      queryFn: (metaData) => fetcher<GetRelationshipStatusQuery, GetRelationshipStatusQueryVariables>(client, GetRelationshipStatusDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetRelationshipStatusQuery.getKey = (variables: GetRelationshipStatusQueryVariables) => ['GetRelationshipStatus.infinite', variables];


useGetRelationshipStatusQuery.fetcher = (client: GraphQLClient, variables: GetRelationshipStatusQueryVariables, headers?: RequestInit['headers']) => fetcher<GetRelationshipStatusQuery, GetRelationshipStatusQueryVariables>(client, GetRelationshipStatusDocument, variables, headers);

export const GetMutualFollowersDocument = /*#__PURE__*/ `
    query GetMutualFollowers($userId: ID!, $targetUserId: ID!, $first: Int) {
  mutualFollowers(userId: $userId, targetUserId: $targetUserId, first: $first) {
    userId
    username
    displayName
    profileImageUrl
    bio
    stats {
      followersCount
    }
  }
}
    `;

export const useGetMutualFollowersQuery = <
      TData = GetMutualFollowersQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetMutualFollowersQueryVariables,
      options?: Omit<UseQueryOptions<GetMutualFollowersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetMutualFollowersQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetMutualFollowersQuery, TError, TData>(
      {
    queryKey: ['GetMutualFollowers', variables],
    queryFn: fetcher<GetMutualFollowersQuery, GetMutualFollowersQueryVariables>(client, GetMutualFollowersDocument, variables, headers),
    ...options
  }
    )};

useGetMutualFollowersQuery.getKey = (variables: GetMutualFollowersQueryVariables) => ['GetMutualFollowers', variables];

export const useInfiniteGetMutualFollowersQuery = <
      TData = InfiniteData<GetMutualFollowersQuery>,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetMutualFollowersQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetMutualFollowersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetMutualFollowersQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useInfiniteQuery<GetMutualFollowersQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetMutualFollowers.infinite', variables],
      queryFn: (metaData) => fetcher<GetMutualFollowersQuery, GetMutualFollowersQueryVariables>(client, GetMutualFollowersDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetMutualFollowersQuery.getKey = (variables: GetMutualFollowersQueryVariables) => ['GetMutualFollowers.infinite', variables];


useGetMutualFollowersQuery.fetcher = (client: GraphQLClient, variables: GetMutualFollowersQueryVariables, headers?: RequestInit['headers']) => fetcher<GetMutualFollowersQuery, GetMutualFollowersQueryVariables>(client, GetMutualFollowersDocument, variables, headers);

export const GetUserDocument = /*#__PURE__*/ `
    query GetUser($userId: ID!) {
  user(userId: $userId) {
    userId
    username
    displayName
    profileImageUrl
    bio
    stats {
      followersCount
      followingCount
      postsCount
    }
    relationshipWithCurrentUser {
      isFollowing
      isFollowedBy
      isMutual
    }
  }
}
    `;

export const useGetUserQuery = <
      TData = GetUserQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetUserQueryVariables,
      options?: Omit<UseQueryOptions<GetUserQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetUserQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetUserQuery, TError, TData>(
      {
    queryKey: ['GetUser', variables],
    queryFn: fetcher<GetUserQuery, GetUserQueryVariables>(client, GetUserDocument, variables, headers),
    ...options
  }
    )};

useGetUserQuery.getKey = (variables: GetUserQueryVariables) => ['GetUser', variables];

export const useInfiniteGetUserQuery = <
      TData = InfiniteData<GetUserQuery>,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetUserQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetUserQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetUserQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useInfiniteQuery<GetUserQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetUser.infinite', variables],
      queryFn: (metaData) => fetcher<GetUserQuery, GetUserQueryVariables>(client, GetUserDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetUserQuery.getKey = (variables: GetUserQueryVariables) => ['GetUser.infinite', variables];


useGetUserQuery.fetcher = (client: GraphQLClient, variables: GetUserQueryVariables, headers?: RequestInit['headers']) => fetcher<GetUserQuery, GetUserQueryVariables>(client, GetUserDocument, variables, headers);

export const GetUserByUsernameDocument = /*#__PURE__*/ `
    query GetUserByUsername($username: String!) {
  userByUsername(username: $username) {
    userId
    username
    displayName
    profileImageUrl
    bio
    stats {
      followersCount
      followingCount
      postsCount
    }
    relationshipWithCurrentUser {
      isFollowing
      isFollowedBy
      isMutual
    }
  }
}
    `;

export const useGetUserByUsernameQuery = <
      TData = GetUserByUsernameQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetUserByUsernameQueryVariables,
      options?: Omit<UseQueryOptions<GetUserByUsernameQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetUserByUsernameQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetUserByUsernameQuery, TError, TData>(
      {
    queryKey: ['GetUserByUsername', variables],
    queryFn: fetcher<GetUserByUsernameQuery, GetUserByUsernameQueryVariables>(client, GetUserByUsernameDocument, variables, headers),
    ...options
  }
    )};

useGetUserByUsernameQuery.getKey = (variables: GetUserByUsernameQueryVariables) => ['GetUserByUsername', variables];

export const useInfiniteGetUserByUsernameQuery = <
      TData = InfiniteData<GetUserByUsernameQuery>,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetUserByUsernameQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetUserByUsernameQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetUserByUsernameQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useInfiniteQuery<GetUserByUsernameQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetUserByUsername.infinite', variables],
      queryFn: (metaData) => fetcher<GetUserByUsernameQuery, GetUserByUsernameQueryVariables>(client, GetUserByUsernameDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetUserByUsernameQuery.getKey = (variables: GetUserByUsernameQueryVariables) => ['GetUserByUsername.infinite', variables];


useGetUserByUsernameQuery.fetcher = (client: GraphQLClient, variables: GetUserByUsernameQueryVariables, headers?: RequestInit['headers']) => fetcher<GetUserByUsernameQuery, GetUserByUsernameQueryVariables>(client, GetUserByUsernameDocument, variables, headers);

export const GetMeDocument = /*#__PURE__*/ `
    query GetMe {
  me {
    userId
    username
    displayName
    profileImageUrl
    bio
    stats {
      followersCount
      followingCount
      postsCount
    }
  }
}
    `;

export const useGetMeQuery = <
      TData = GetMeQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetMeQueryVariables,
      options?: Omit<UseQueryOptions<GetMeQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetMeQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetMeQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetMe'] : ['GetMe', variables],
    queryFn: fetcher<GetMeQuery, GetMeQueryVariables>(client, GetMeDocument, variables, headers),
    ...options
  }
    )};

useGetMeQuery.getKey = (variables?: GetMeQueryVariables) => variables === undefined ? ['GetMe'] : ['GetMe', variables];

export const useInfiniteGetMeQuery = <
      TData = InfiniteData<GetMeQuery>,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetMeQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetMeQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetMeQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useInfiniteQuery<GetMeQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['GetMe.infinite'] : ['GetMe.infinite', variables],
      queryFn: (metaData) => fetcher<GetMeQuery, GetMeQueryVariables>(client, GetMeDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetMeQuery.getKey = (variables?: GetMeQueryVariables) => variables === undefined ? ['GetMe.infinite'] : ['GetMe.infinite', variables];


useGetMeQuery.fetcher = (client: GraphQLClient, variables?: GetMeQueryVariables, headers?: RequestInit['headers']) => fetcher<GetMeQuery, GetMeQueryVariables>(client, GetMeDocument, variables, headers);

export const SearchUsersDocument = /*#__PURE__*/ `
    query SearchUsers($query: String!, $first: Int) {
  searchUsers(query: $query, first: $first) {
    userId
    username
    displayName
    profileImageUrl
    bio
    stats {
      followersCount
    }
    relationshipWithCurrentUser {
      isFollowing
    }
  }
}
    `;

export const useSearchUsersQuery = <
      TData = SearchUsersQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: SearchUsersQueryVariables,
      options?: Omit<UseQueryOptions<SearchUsersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SearchUsersQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<SearchUsersQuery, TError, TData>(
      {
    queryKey: ['SearchUsers', variables],
    queryFn: fetcher<SearchUsersQuery, SearchUsersQueryVariables>(client, SearchUsersDocument, variables, headers),
    ...options
  }
    )};

useSearchUsersQuery.getKey = (variables: SearchUsersQueryVariables) => ['SearchUsers', variables];

export const useInfiniteSearchUsersQuery = <
      TData = InfiniteData<SearchUsersQuery>,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: SearchUsersQueryVariables,
      options: Omit<UseInfiniteQueryOptions<SearchUsersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<SearchUsersQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useInfiniteQuery<SearchUsersQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['SearchUsers.infinite', variables],
      queryFn: (metaData) => fetcher<SearchUsersQuery, SearchUsersQueryVariables>(client, SearchUsersDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      ...restOptions
    }
  })()
    )};

useInfiniteSearchUsersQuery.getKey = (variables: SearchUsersQueryVariables) => ['SearchUsers.infinite', variables];


useSearchUsersQuery.fetcher = (client: GraphQLClient, variables: SearchUsersQueryVariables, headers?: RequestInit['headers']) => fetcher<SearchUsersQuery, SearchUsersQueryVariables>(client, SearchUsersDocument, variables, headers);

export const GetFollowersDocument = /*#__PURE__*/ `
    query GetFollowers($userId: ID!, $first: Int, $after: String) {
  user(userId: $userId) {
    followers(first: $first, after: $after) {
      edges {
        cursor
        node {
          userId
          username
          displayName
          profileImageUrl
          stats {
            followersCount
          }
          relationshipWithCurrentUser {
            isFollowing
          }
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
      totalCount
    }
  }
}
    `;

export const useGetFollowersQuery = <
      TData = GetFollowersQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetFollowersQueryVariables,
      options?: Omit<UseQueryOptions<GetFollowersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetFollowersQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetFollowersQuery, TError, TData>(
      {
    queryKey: ['GetFollowers', variables],
    queryFn: fetcher<GetFollowersQuery, GetFollowersQueryVariables>(client, GetFollowersDocument, variables, headers),
    ...options
  }
    )};

useGetFollowersQuery.getKey = (variables: GetFollowersQueryVariables) => ['GetFollowers', variables];

export const useInfiniteGetFollowersQuery = <
      TData = InfiniteData<GetFollowersQuery>,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetFollowersQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetFollowersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetFollowersQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useInfiniteQuery<GetFollowersQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetFollowers.infinite', variables],
      queryFn: (metaData) => fetcher<GetFollowersQuery, GetFollowersQueryVariables>(client, GetFollowersDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetFollowersQuery.getKey = (variables: GetFollowersQueryVariables) => ['GetFollowers.infinite', variables];


useGetFollowersQuery.fetcher = (client: GraphQLClient, variables: GetFollowersQueryVariables, headers?: RequestInit['headers']) => fetcher<GetFollowersQuery, GetFollowersQueryVariables>(client, GetFollowersDocument, variables, headers);

export const GetFollowingDocument = /*#__PURE__*/ `
    query GetFollowing($userId: ID!, $first: Int, $after: String) {
  user(userId: $userId) {
    following(first: $first, after: $after) {
      edges {
        cursor
        node {
          userId
          username
          displayName
          profileImageUrl
          stats {
            followersCount
          }
          relationshipWithCurrentUser {
            isFollowing
          }
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
      totalCount
    }
  }
}
    `;

export const useGetFollowingQuery = <
      TData = GetFollowingQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetFollowingQueryVariables,
      options?: Omit<UseQueryOptions<GetFollowingQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetFollowingQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetFollowingQuery, TError, TData>(
      {
    queryKey: ['GetFollowing', variables],
    queryFn: fetcher<GetFollowingQuery, GetFollowingQueryVariables>(client, GetFollowingDocument, variables, headers),
    ...options
  }
    )};

useGetFollowingQuery.getKey = (variables: GetFollowingQueryVariables) => ['GetFollowing', variables];

export const useInfiniteGetFollowingQuery = <
      TData = InfiniteData<GetFollowingQuery>,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetFollowingQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetFollowingQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetFollowingQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useInfiniteQuery<GetFollowingQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetFollowing.infinite', variables],
      queryFn: (metaData) => fetcher<GetFollowingQuery, GetFollowingQueryVariables>(client, GetFollowingDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetFollowingQuery.getKey = (variables: GetFollowingQueryVariables) => ['GetFollowing.infinite', variables];


useGetFollowingQuery.fetcher = (client: GraphQLClient, variables: GetFollowingQueryVariables, headers?: RequestInit['headers']) => fetcher<GetFollowingQuery, GetFollowingQueryVariables>(client, GetFollowingDocument, variables, headers);

export const GetFollowersByUsernameDocument = /*#__PURE__*/ `
    query GetFollowersByUsername($username: String!, $first: Int, $after: String) {
  userByUsername(username: $username) {
    userId
    username
    displayName
    profileImageUrl
    bio
    stats {
      followersCount
      followingCount
      postsCount
    }
    relationshipWithCurrentUser {
      isFollowing
      isFollowedBy
      isMutual
    }
    followers(first: $first, after: $after) {
      edges {
        cursor
        followedAt
        isMutual
        node {
          userId
          username
          displayName
          profileImageUrl
          bio
          stats {
            followersCount
          }
          relationshipWithCurrentUser {
            isFollowing
          }
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
      totalCount
    }
  }
}
    `;

export const useGetFollowersByUsernameQuery = <
      TData = GetFollowersByUsernameQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetFollowersByUsernameQueryVariables,
      options?: Omit<UseQueryOptions<GetFollowersByUsernameQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetFollowersByUsernameQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetFollowersByUsernameQuery, TError, TData>(
      {
    queryKey: ['GetFollowersByUsername', variables],
    queryFn: fetcher<GetFollowersByUsernameQuery, GetFollowersByUsernameQueryVariables>(client, GetFollowersByUsernameDocument, variables, headers),
    ...options
  }
    )};

useGetFollowersByUsernameQuery.getKey = (variables: GetFollowersByUsernameQueryVariables) => ['GetFollowersByUsername', variables];

export const useInfiniteGetFollowersByUsernameQuery = <
      TData = InfiniteData<GetFollowersByUsernameQuery>,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetFollowersByUsernameQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetFollowersByUsernameQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetFollowersByUsernameQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useInfiniteQuery<GetFollowersByUsernameQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetFollowersByUsername.infinite', variables],
      queryFn: (metaData) => fetcher<GetFollowersByUsernameQuery, GetFollowersByUsernameQueryVariables>(client, GetFollowersByUsernameDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetFollowersByUsernameQuery.getKey = (variables: GetFollowersByUsernameQueryVariables) => ['GetFollowersByUsername.infinite', variables];


useGetFollowersByUsernameQuery.fetcher = (client: GraphQLClient, variables: GetFollowersByUsernameQueryVariables, headers?: RequestInit['headers']) => fetcher<GetFollowersByUsernameQuery, GetFollowersByUsernameQueryVariables>(client, GetFollowersByUsernameDocument, variables, headers);

export const GetFollowingByUsernameDocument = /*#__PURE__*/ `
    query GetFollowingByUsername($username: String!, $first: Int, $after: String) {
  userByUsername(username: $username) {
    userId
    username
    displayName
    profileImageUrl
    bio
    stats {
      followersCount
      followingCount
      postsCount
    }
    relationshipWithCurrentUser {
      isFollowing
      isFollowedBy
      isMutual
    }
    following(first: $first, after: $after) {
      edges {
        cursor
        followedAt
        isMutual
        node {
          userId
          username
          displayName
          profileImageUrl
          bio
          stats {
            followersCount
          }
          relationshipWithCurrentUser {
            isFollowing
          }
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
      totalCount
    }
  }
}
    `;

export const useGetFollowingByUsernameQuery = <
      TData = GetFollowingByUsernameQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetFollowingByUsernameQueryVariables,
      options?: Omit<UseQueryOptions<GetFollowingByUsernameQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetFollowingByUsernameQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetFollowingByUsernameQuery, TError, TData>(
      {
    queryKey: ['GetFollowingByUsername', variables],
    queryFn: fetcher<GetFollowingByUsernameQuery, GetFollowingByUsernameQueryVariables>(client, GetFollowingByUsernameDocument, variables, headers),
    ...options
  }
    )};

useGetFollowingByUsernameQuery.getKey = (variables: GetFollowingByUsernameQueryVariables) => ['GetFollowingByUsername', variables];

export const useInfiniteGetFollowingByUsernameQuery = <
      TData = InfiniteData<GetFollowingByUsernameQuery>,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetFollowingByUsernameQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetFollowingByUsernameQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetFollowingByUsernameQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useInfiniteQuery<GetFollowingByUsernameQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetFollowingByUsername.infinite', variables],
      queryFn: (metaData) => fetcher<GetFollowingByUsernameQuery, GetFollowingByUsernameQueryVariables>(client, GetFollowingByUsernameDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetFollowingByUsernameQuery.getKey = (variables: GetFollowingByUsernameQueryVariables) => ['GetFollowingByUsername.infinite', variables];


useGetFollowingByUsernameQuery.fetcher = (client: GraphQLClient, variables: GetFollowingByUsernameQueryVariables, headers?: RequestInit['headers']) => fetcher<GetFollowingByUsernameQuery, GetFollowingByUsernameQueryVariables>(client, GetFollowingByUsernameDocument, variables, headers);

export const CheckRelationshipDocument = /*#__PURE__*/ `
    query CheckRelationship($userId: ID!, $targetUserId: ID!) {
  checkRelationship(userId: $userId, targetUserId: $targetUserId) {
    isFollowing
    isFollowedBy
    isMutual
    followedAt
    followedBackAt
  }
}
    `;

export const useCheckRelationshipQuery = <
      TData = CheckRelationshipQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: CheckRelationshipQueryVariables,
      options?: Omit<UseQueryOptions<CheckRelationshipQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CheckRelationshipQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<CheckRelationshipQuery, TError, TData>(
      {
    queryKey: ['CheckRelationship', variables],
    queryFn: fetcher<CheckRelationshipQuery, CheckRelationshipQueryVariables>(client, CheckRelationshipDocument, variables, headers),
    ...options
  }
    )};

useCheckRelationshipQuery.getKey = (variables: CheckRelationshipQueryVariables) => ['CheckRelationship', variables];

export const useInfiniteCheckRelationshipQuery = <
      TData = InfiniteData<CheckRelationshipQuery>,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: CheckRelationshipQueryVariables,
      options: Omit<UseInfiniteQueryOptions<CheckRelationshipQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CheckRelationshipQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useInfiniteQuery<CheckRelationshipQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['CheckRelationship.infinite', variables],
      queryFn: (metaData) => fetcher<CheckRelationshipQuery, CheckRelationshipQueryVariables>(client, CheckRelationshipDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      ...restOptions
    }
  })()
    )};

useInfiniteCheckRelationshipQuery.getKey = (variables: CheckRelationshipQueryVariables) => ['CheckRelationship.infinite', variables];


useCheckRelationshipQuery.fetcher = (client: GraphQLClient, variables: CheckRelationshipQueryVariables, headers?: RequestInit['headers']) => fetcher<CheckRelationshipQuery, CheckRelationshipQueryVariables>(client, CheckRelationshipDocument, variables, headers);

export const GetFollowSuggestionsDocument = /*#__PURE__*/ `
    query GetFollowSuggestions($limit: Int) {
  followSuggestions(limit: $limit) {
    user {
      userId
      username
      displayName
      profileImageUrl
      bio
      stats {
        followersCount
      }
    }
    reason
    mutualFollowersCount
    mutualFollowers {
      userId
      username
      displayName
      profileImageUrl
    }
    score
  }
}
    `;

export const useGetFollowSuggestionsQuery = <
      TData = GetFollowSuggestionsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetFollowSuggestionsQueryVariables,
      options?: Omit<UseQueryOptions<GetFollowSuggestionsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetFollowSuggestionsQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetFollowSuggestionsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetFollowSuggestions'] : ['GetFollowSuggestions', variables],
    queryFn: fetcher<GetFollowSuggestionsQuery, GetFollowSuggestionsQueryVariables>(client, GetFollowSuggestionsDocument, variables, headers),
    ...options
  }
    )};

useGetFollowSuggestionsQuery.getKey = (variables?: GetFollowSuggestionsQueryVariables) => variables === undefined ? ['GetFollowSuggestions'] : ['GetFollowSuggestions', variables];

export const useInfiniteGetFollowSuggestionsQuery = <
      TData = InfiniteData<GetFollowSuggestionsQuery>,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetFollowSuggestionsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetFollowSuggestionsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetFollowSuggestionsQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useInfiniteQuery<GetFollowSuggestionsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['GetFollowSuggestions.infinite'] : ['GetFollowSuggestions.infinite', variables],
      queryFn: (metaData) => fetcher<GetFollowSuggestionsQuery, GetFollowSuggestionsQueryVariables>(client, GetFollowSuggestionsDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetFollowSuggestionsQuery.getKey = (variables?: GetFollowSuggestionsQueryVariables) => variables === undefined ? ['GetFollowSuggestions.infinite'] : ['GetFollowSuggestions.infinite', variables];


useGetFollowSuggestionsQuery.fetcher = (client: GraphQLClient, variables?: GetFollowSuggestionsQueryVariables, headers?: RequestInit['headers']) => fetcher<GetFollowSuggestionsQuery, GetFollowSuggestionsQueryVariables>(client, GetFollowSuggestionsDocument, variables, headers);
